module.exports = __webpack_public_path__ + "static/images/dumbbell.2662828212a4a8c8b81779f857fb6340.svg";